module.exports = __webpack_public_path__ + "img/bb_g3_eyes-02.062dc1ac.svg";